// extracted by mini-css-extract-plugin
export default {"overview-info-general":"_1ABHHUiwpJ","overviewInfoGeneral":"_1ABHHUiwpJ","table":"_3qEcLNpS61","attributes":"UBMVyrMq4R","attributes-entry":"VGdmn183_h","attributesEntry":"VGdmn183_h","last-child":"_2XDJEPukQq","lastChild":"_2XDJEPukQq","key":"uex9Wyt0Tf","value":"ZcTpdnZ7KO","tabs":"_2F3bNNrgmx","tabs-general":"Z0CdaiyZc4","tabsGeneral":"Z0CdaiyZc4"};
    if(module.hot) {
      // 1627035587340
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  